function initMasonry() {
    if ($('.grid').length){
        $('.grid').masonry({
        // options
        itemSelector: '.grid-item',
        });
    }
};